import { updateWasOnlineMeetingEverAutoSet } from 'owa-calendar-compose-form-actions';
import getComposeViewState from '../selectors/getComposeViewState';
import { mutator } from 'satcheljs';

export default mutator(updateWasOnlineMeetingEverAutoSet, () => {
    const composeViewState = getComposeViewState();
    // TODO: Bug 116677: Reply with meeting - Setting wasOnlineMeetingEverAutoSet through handleComposePopoutForMeetingDraft doesn't happen because composeViewState isn't available yet
    // The view state should ideally be ready when this is called from handleComposePopoutForMeetingDraft / onlineMeetingsOrchestrator.
    if (composeViewState) {
        composeViewState.wasOnlineMeetingEverAutoSet = true;
    }
});
